module.exports = __webpack_public_path__ + "img/Artboard9.f5449392.webp";